import { Grid, withStyles } from "@material-ui/core";
import { useTranslations } from "adapters/i18n";
import React from "react";
import { FeedBackPage, TextLabel } from "../../shared/components";

export const NoDetailedOperationsFeedback = ({ classes }) => {
  const { t } = useTranslations();

  const message = t("movements:no-category-operations-for-period");

  return (
    <Grid container direction="column" justify="center">
      <FeedBackPage>
        <Grid container direction="column" alignItems="center">
          <img
            className={classes.image}
            src="../images/fechamentoTelaVazia.png"
            alt={message}
          />
          <TextLabel className={classes.text}>{message}</TextLabel>
        </Grid>
      </FeedBackPage>
    </Grid>
  );
};

const styles = () => ({
  text: {
    fontSize: "12px",
    color: "#666666",
    fontFamily: "Roboto",
  },
  image: {
    position: "relative",
    top: "-30px",
    width: "150px",
    height: "150px",
    margin: "20px",
  },
});

export default withStyles(styles)(NoDetailedOperationsFeedback);
